/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Shared fields and validation for planner request serializers.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface PlannerViewRequest { 
    appointmentTypeIds: Array<number>;
    therapistIds: Array<number>;
    fromDate: string;
    toDate: string;
}
export const PlannerViewRequest_appointmentTypeIds_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PlannerViewRequest_therapistIds_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PlannerViewRequest_fromDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PlannerViewRequest_toDate_Validators: ValidatorFn[] =
    [  Validators.required, ];


